import forEach from '../../../../javascripts/dom/forEach';

const video75 = document.querySelectorAll('[data-js-module="o-video-75"]');

const init = async () => {
  const { default: Video75 } = await import(/* webpackChunkName: "o-video75" */ './video75');
  forEach(video75, (index, element) => new Video75(element));
};

if (video75.length) init();
